import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HeaderFooterVisibilityService } from '@app/shared/services/header-footer-visibility.service';
import { LocalStorageService } from '@app/shared/services/storage/local-storage.service';
import { isNil } from 'lodash';
import { CookieService } from 'ngx-cookie-service';

declare let require: any;
const manifest = require('./error.manifest.json');

interface ErrorManifestAction {
  text: string;
  routerlink?: string[];
  link?: string;
}

interface ErrorManifestRecord {
  heading: string;
  content: string;
  actions: Array<ErrorManifestAction>;
}

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ErrorComponent implements OnInit {
  public errormanifest: ErrorManifestRecord = {} as ErrorManifestRecord;

  constructor(
    public headerFooterVisibilityService: HeaderFooterVisibilityService,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService,
    private cookieService: CookieService,
  ) {
    this.route.params.subscribe((params) => {
      const errortype = params.errorid;
      this.errormanifest = manifest[errortype] || manifest.default;

      if (errortype === '401.2') {
        const municipality = this.route.snapshot.queryParamMap.get('municipality');
        this.errormanifest.content = this.errormanifest.content.replace('[]', municipality as string);
      }
    });
  }

  ngOnInit() {
    if (window.location.pathname === '/error/401') {
      sessionStorage.clear();
      this.localStorage.clear();
      this.cookieService.deleteAll('/');
    }

    this.headerFooterVisibilityService.isFooterVisible = false;
  }

  isRouterLinkAction(action: ErrorManifestAction): boolean {
    return !isNil(action.routerlink) && !!action.routerlink.length;
  }
}
